// extracted by mini-css-extract-plugin
module.exports = {"notFound":"notFound_ydWPJ","header":"header_27qiR","footer":"footer_3ZXQy"};